import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

class NRTTable extends React.Component {

    fieldNames = []


    componentWillMount() {
        this.props.headers.forEach((header) => this.fieldNames.push(header.fieldName))
    }


    render() {

        const props = this.props
        let cont = 0

        return (
            <table className={'nrt-table'}>
                {
                    (!props.hideHeaders) &&
                    <thead>
                    <tr>
                        {
                            props.headers.map((header, index) => {
                                return (

                                    <th key={header.title+index}
                                        style={header.style}>
                                        {header.title}
                                    </th>
                                )
                            })
                        }
                        {
                            props.buttons.length > 0 &&
                                <th/>
                        }
                    </tr>
                    </thead>
                }

                <tbody>
                {props.data.map((row, rowIndex) => {

                    const className = cont++ % 2 === 0 ? '' : 'odd'

                    return (
                        <tr className={className} key={'row-' + rowIndex}>
                            {
                                this.fieldNames.map((fieldName) => {
                                return (
                                    <td key={`row-${rowIndex}-${fieldName}`}>
                                        { row[fieldName] }
                                    </td>
                                )
                            })
                            }

                            {
                                props.buttons.length > 0 &&
                                <td style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    {
                                        props.buttons.map((Button, index) =>

                                            <div key={`row-${rowIndex}-buttons-${index}`}
                                                 style={{marginLeft: '1rem'}}>
                                                {
                                                    React.cloneElement(Button, {
                                                        onClick: () => {
                                                            Button.props.onClick(row, rowIndex)
                                                        }
                                                    })
                                                }
                                            </div>
                                        )
                                    }
                                </td>
                            }


                        </tr>
                    )
                })}
                </tbody>
            </table>
        )
    }
}

NRTTable.propTypes = {
    headers: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    stripes: PropTypes.bool,
    buttons: PropTypes.array,
}

NRTTable.defaultProps = {
    stripes: true,
    buttons: [],
    hideHeaders: false
}

export default NRTTable



// WEBPACK FOOTER //
// ./src/components/_common/Table/index.js